import React from 'react';
import { SubmitButton, AfterSubmitFunc } from 'ui-builder';
import { EventTask, useProjectTasksService } from 'nekst-api';
import BaseEventTaskForm from './BaseEventTaskForm';

export interface CreateEventTaskFormProps {
  afterSubmitFunc?: AfterSubmitFunc;
  projectId?: number;
}

export default function CreateEventTaskForm(props: CreateEventTaskFormProps) {
  const projectTasksService = useProjectTasksService();

  const initialData = {
    projectId: props.projectId,
  } as EventTask;

  return (
    <BaseEventTaskForm
      submitFormFunc={(formData) => projectTasksService.createEventTask(formData.projectId, formData)}
      title="Add Event Task"
      buttons={<SubmitButton text="Save task" key="save" />}
      afterSubmitFunc={props.afterSubmitFunc}
      initialData={initialData}
      showProjectDropdown={!props.projectId}
    />
  );
}
